export default {
      id: "md_fuel-usage",
      viewBox: "0 0 17 18",
      url: __webpack_public_path__ + "img/icons.svg#md_fuel",
      toString: function () {
        return this.url;
      }
    }